<div fxLayout="row">
  <img [src]="documentInfo.fileExtension | fileTypeIcon" [width]='32' [height]="32" alt="file-ext" />

  <div fxLayout="column">
    <div fxLayout="row">
      <strong *ngIf="documentInfo.documentKindId !== otherDocumentKind">{{ documentInfo.documentKindId |
        staticDictionaryCaption:'documentKind' |async }}</strong>
    </div>

    <strong *ngIf="documentInfo.documentKindId === otherDocumentKind">{{ documentInfo.otherDocumentKindName }}</strong>

    <div role="none" fxLayout="row" fxLayoutGap="3px" (click)="editDescription()">
      <i class="description-link">{{ documentInfo.description }}</i>
      <div *ngIf="!documentInfo.description">
        <kendo-icon [name]="'plus'"></kendo-icon>
        <i class="description-link-small">{{'claims-center.claimDocumentation.addDescription' | translate}}</i>
      </div>
    </div>
  </div>

  <div *ngIf="documentInfo.isSigned">
    <kendo-icon size="xxlarge" [name]="'signature'" themeColor="success" title="{{'claims-center.claimDocumentation.documentSigned' | translate}}"></kendo-icon>
  </div>


</div>

<div kendoDialogContainer #descriptionDialog></div>
